import { render, staticRenderFns } from "./EventGroup.vue?vue&type=template&id=410004d6"
import script from "./EventGroup.vue?vue&type=script&lang=js"
export * from "./EventGroup.vue?vue&type=script&lang=js"
import style0 from "./EventGroup.vue?vue&type=style&index=0&id=410004d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports